import React from "react";
import KuikaEmptyState from "../../../../ui-kit/kuika-empty-state/kuika-empty-state";

export const RoleManagementEmptyState: React.FC = () => (
  <div className="role-management-empty-state">
    <div className="role-management-empty-content">
      <KuikaEmptyState svgName="key" name="Key" customName="No key found" description="Simply add a new key." />
    </div>
  </div>
);
